import { isAlbum } from 'reactApp/modules/albums/albums.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { selectItemsFromCloudToVigboAlbum, selectVigboAlbumAndAddItems } from 'reactApp/modules/vigbo/vigbo.module';
import { store as reduxStore } from 'reactApp/store';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import { getSelectedItems } from './helpers/getSelectedItems';
import { getSelectedItemsOrCurrentFolder } from './helpers/getSelectedItemsOrCurrentFolder';

export const addToVigboAlbum = (place?: string) => {
    const state = reduxStore.getState();

    const storage = getCurrentStorage(state);
    const selectedItems = getSelectedItemsOrCurrentFolder();
    const isVigboAlbumItem = selectedItems.length === 1 && isAlbum(selectedItems?.[0]);

    if (storage === EStorageType.vigbo && isVigboAlbumItem) {
        sendPaymentGa({
            eventCategory: ECategoryGa.vigbo,
            action: 'add-files-to-gallery',
            place: 'toolbar-in-vigbo',
        });
        reduxStore.dispatch(selectItemsFromCloudToVigboAlbum({ albumId: selectedItems?.[0]?.id }));
        return;
    }

    sendPaymentGa({
        eventCategory: ECategoryGa.vigbo,
        action: 'add-files-to-gallery',
        place,
    });

    const items = getSelectedItems(state) || [];
    if (!items?.length) {
        return;
    }

    reduxStore.dispatch(selectVigboAlbumAndAddItems({ items }));
};
